module.exports = __webpack_public_path__ + "img/kiosk-map-wayfinder.be5f4be1.jpg";